<template><div><h1>VUX V2.5.1 发布日志</h1>
<h2><a href="/zh-CN/components/group.html">Group</a></h2>
<ul><li>[feature] 添加 slot:title #1650</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] 修复 array-from 在 webpack@3 下报错问题 #1649</li>
</ul>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[feature] 添加方法 updateAutosize 在存在默认值的情况下手动重置高度</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复插件形式使用时缺失样式导致报错问题 #1659</li>
</ul>
<h2><a href="/zh-CN/components/transfer-dom.html">TransferDom</a></h2>
<ul><li>[enhance] 默认不在组件内容更新时自动重新渲染，修复 popup-picker 关闭闪现体验问题</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.1-239.vue?360233fa